module.exports = __webpack_public_path__ + "static/media/KHOF01.e2ebcd38.jpg";